import { z } from 'zod';

export const MAX_STATIC_FILE_BYTES = 512 * 1024 * 1024;
export const STATIC_FILE_CHUNK_BYTES = 512 * 1024;

/** Relative public paths only: no hidden files, traversal, or URL escape sequences. */
export function isStaticFilePath(value: string): boolean {
  return (
    value.length > 0 &&
    value.length <= 512 &&
    value
      .split('/')
      .every(
        (part) =>
          part.length <= 128 &&
          /^[a-zA-Z0-9_]/.test(part) &&
          !/[^a-zA-Z0-9_. -]/.test(part) &&
          !/[. ]$/.test(part),
      )
  );
}

export const StaticFilePathSchema = z.string().refine(isStaticFilePath, {
  message: 'Use a relative file path with letters, numbers, spaces, dots, underscores, or hyphens.',
});

export const staticFileUrl = (fileName: string): string =>
  `/media/${fileName.split('/').map(encodeURIComponent).join('/')}`;

export const StaticFileSchema = z.object({
  fileName: StaticFilePathSchema,
  size: z.number().int().positive(),
  modifiedAt: z.iso.datetime(),
  url: z.string(),
});
export type StaticFile = z.infer<typeof StaticFileSchema>;

export const AdminStaticFilesSchema = z.object({
  files: z.array(StaticFileSchema),
  maxBytes: z.number().int().positive(),
});
export type AdminStaticFiles = z.infer<typeof AdminStaticFilesSchema>;

export const StaticFileUploadSchema = z.object({
  uploadId: z.uuid(),
  chunkBytes: z.number().int().positive().max(STATIC_FILE_CHUNK_BYTES),
});

export const StaticFileUploadProgressSchema = z.object({
  receivedBytes: z.number().int().nonnegative(),
});
